import type { MisconceptionDefinition } from '../types';

/** SPR — Franse leenwoorden (slice 4). */
export const fransLeenwoordenMisconceptions: MisconceptionDefinition[] = [{
  id: 'spr.leen-fonetisch-schrijven',
  label: 'Leenwoord fonetisch geschreven',
  module: 'SpellingRegel',
  description: 'Leerling schrijft een Frans leenwoord fonetisch (bijv. "kado" i.p.v. "cadeau").',
  typicalFamilies: ['SPR-LEEN-FRANS']
}, {
  id: 'spr.leen-dubbele-klinker',
  label: 'Dubbele klinker bij leenwoord',
  module: 'SpellingRegel',
  description: 'Leerling verdubbelt een klinker voor de lange klank bij een leenwoord (bijv. "kadoo").',
  typicalFamilies: ['SPR-LEEN-FRANS']
}, {
  id: 'spr.leen-half-frans',
  label: 'Half-Franse spelling',
  module: 'SpellingRegel',
  description: 'Leerling herkent het begin van een Frans woord maar niet de uitgang (bijv. "cadoo").',
  typicalFamilies: ['SPR-LEEN-FRANS']
}, {
  id: 'spr.leen-oir-als-oar',
  label: 'Schrijft -oir als -oar',
  module: 'SpellingRegel',
  description: 'Leerling schrijft de Franse uitgang -oir als -oar.',
  typicalFamilies: ['SPR-LEEN-FRANS']
}, {
  id: 'spr.leen-fonetisch-trotwar',
  label: 'Trottoir fonetisch geschreven',
  module: 'SpellingRegel',
  description: 'Leerling schrijft trottoir fonetisch als "trotwar".',
  typicalFamilies: ['SPR-LEEN-FRANS']
}, {
  id: 'spr.leen-verkeerde-uitgang-uar',
  label: 'Verzint uitgang -uar',
  module: 'SpellingRegel',
  description: 'Leerling verzint een niet-bestaande uitgang -uar bij een Frans leenwoord.',
  typicalFamilies: ['SPR-LEEN-FRANS']
}, {
  id: 'spr.leen-au-als-ou',
  label: 'Schrijft -au- als -ou-',
  module: 'SpellingRegel',
  description: 'Leerling schrijft de Franse -au- als -ou- (bijv. "restourant").',
  typicalFamilies: ['SPR-LEEN-FRANS']
}, {
  id: 'spr.leen-ant-als-and',
  label: 'Schrijft -ant als -and',
  module: 'SpellingRegel',
  description: 'Leerling schrijft de Franse uitgang -ant als -and.',
  typicalFamilies: ['SPR-LEEN-FRANS']
}, {
  id: 'spr.leen-au-weggelaten',
  label: 'Laat -au- weg',
  module: 'SpellingRegel',
  description: 'Leerling laat de -au- lettercombinatie weg in een Frans leenwoord.',
  typicalFamilies: ['SPR-LEEN-FRANS']
}, {
  id: 'spr.leen-age-als-asje',
  label: 'Schrijft -age als -asje',
  module: 'SpellingRegel',
  description: 'Leerling schrijft de Franse uitgang -age fonetisch als -asje.',
  typicalFamilies: ['SPR-LEEN-FRANS']
}, {
  id: 'spr.leen-age-als-aazje',
  label: 'Schrijft -age als -aazje',
  module: 'SpellingRegel',
  description: 'Leerling schrijft de Franse uitgang -age als -aazje.',
  typicalFamilies: ['SPR-LEEN-FRANS']
}, {
  id: 'spr.leen-dubbele-r',
  label: 'Verdubbelt r bij leenwoord',
  module: 'SpellingRegel',
  description: 'Leerling verdubbelt de r in een Frans leenwoord (bijv. "garrage").',
  typicalFamilies: ['SPR-LEEN-FRANS']
}, {
  id: 'spr.leen-balkon-als-frans',
  label: 'Balkon als Frans gezien',
  module: 'SpellingRegel',
  description: 'Leerling denkt dat "balkon" een Frans leenwoord is (is Italiaans).',
  typicalFamilies: ['SPR-LEEN-FRANS']
}, {
  id: 'spr.leen-hotel-als-frans',
  label: 'Hotel als Frans gezien',
  module: 'SpellingRegel',
  description: 'Leerling denkt dat "hotel" een Frans leenwoord is (is Latijn).',
  typicalFamilies: ['SPR-LEEN-FRANS']
}, {
  id: 'spr.leen-uitzicht-als-leen',
  label: 'Uitzicht als leenwoord gezien',
  module: 'SpellingRegel',
  description: 'Leerling denkt dat "uitzicht" een leenwoord is (is Nederlands).',
  typicalFamilies: ['SPR-LEEN-FRANS']
}, {
  id: 'spr.leen-parasol-als-nl',
  label: 'Parasol als Nederlands gezien',
  module: 'SpellingRegel',
  description: 'Leerling denkt dat "parasol" een Nederlands woord is (is Frans).',
  typicalFamilies: ['SPR-LEEN-FRANS']
}, {
  id: 'spr.leen-terras-als-nl',
  label: 'Terras als Nederlands gezien',
  module: 'SpellingRegel',
  description: 'Leerling denkt dat "terras" een Nederlands woord is (is Frans).',
  typicalFamilies: ['SPR-LEEN-FRANS']
}, {
  id: 'spr.leen-brochure-als-nl',
  label: 'Brochure als Nederlands gezien',
  module: 'SpellingRegel',
  description: 'Leerling denkt dat "brochure" een Nederlands woord is (is Frans).',
  typicalFamilies: ['SPR-LEEN-FRANS']
}];